import { render, staticRenderFns } from "./network-statistics-card.vue?vue&type=template&id=a267456a&scoped=true&"
import script from "./network-statistics-card.vue?vue&type=script&lang=ts&"
export * from "./network-statistics-card.vue?vue&type=script&lang=ts&"
import style0 from "./network-statistics-card.vue?vue&type=style&index=0&id=a267456a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a267456a",
  null
  
)

export default component.exports